import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Container } from 'react-bootstrap';
import Sidebar from './Sidebar';
import configAdmin from './configAdmin.json';
import { updatePageContent, getPageByCode, addObservatoryPage, updateObservatoryPage } from './apiCalls';
import ToastConfirmation from './ToastConfirmation';
import { nanoid } from 'nanoid';
import { useParams } from 'react-router';

const { MIGRATIONPAGE_CODE } = configAdmin

export default function ObservatoryPagesAdd() {
  let { pagecode } = useParams();
  const [showToaster, setShowToaster] = useState(false);
  const [pageContent, setPageContent] = useState({});
  const [pageContentFormData, setPageConentFormData] = useState({});

	
		// EDIT MODE
		useEffect(() => {
      if ( pagecode ) {
        getPageByCode(pagecode, (resp) => {
          setPageContent(resp);
        });
      }
		}, []);

  const submitForm = () => {
    const codeID = pagecode ? pagecode : nanoid(16);

    const mainConfigformDataSubmit = {
      ...pageContent,
      ...pageContentFormData
    }


    let pagesInfo = {
      id: mainConfigformDataSubmit.id,
      name: mainConfigformDataSubmit.title,
      code: codeID,
      lang: 'es',
      title: mainConfigformDataSubmit.title,
      application_id: '0',
      content: mainConfigformDataSubmit.content
    };

		if ( pagecode ) {
			updateObservatoryPage( pagecode, pagesInfo, (response) => {
				console.log('forms');
				console.log(JSON.parse(response));
				setShowToaster(true);
			});
		}
		else {
			addObservatoryPage( pagesInfo, (response) => {
				console.log('forms');
				console.log(JSON.parse(response));
        setShowToaster(true);
			});
		}

  };


  const formContent = (
    <Form>
      <Form.Group className="admin-content-group">
      <Form.Label className="admin-content-form-label">Titulo</Form.Label>
      <Form.Control
          placeholder="Titulo"
          defaultValue={ pageContent?.title && pageContent.title }
          onChange={ (e) => {
            setPageConentFormData({
                ...pageContentFormData,
                title: e.target.value
            });
          } }  
        />
      </Form.Group>

      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Contenido</Form.Label>
        <Form.Control
          as="textarea"
          rows={10}
          defaultValue={ pageContent?.content && pageContent.content }
          onChange={ (e) => {
            setPageConentFormData({
                ...pageContentFormData,
                content: e.target.value
            });
            } } 
        />
      </Form.Group>
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {submitForm();}}>Guardar</Button>

    </Form>
  )

  return (
    <Container fluid>
      <p>{/* JSON.stringify( pageContentFormData ) */}</p>
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contenido guardado con éxito!' }/>
            <Card>
              <Card.Header> Página de Observatorio </Card.Header>
              <Card.Body>{ formContent }</Card.Body>
            </Card>
          </Col> 
      </Row>
    </Container>
  )
}  